import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from "../../elements/Modal";
import { Slideshow } from "../Slideshow";
import { testidFactory } from "../../../utils/testid";
var TEST_ID_PREFIX = 'gallery';
var testid = testidFactory(TEST_ID_PREFIX);
export var Component = function Component(_ref) {
  var images = _ref.images,
      trigger = _ref.trigger,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      startIndex = _ref.startIndex;
  var areThumbnailsActive = images.length > 1;
  return React.createElement(Modal, {
    className: "is-lightbox",
    "data-testid": testid(),
    hasCloseIcon: true,
    isFullscreen: true,
    isOpen: isOpen,
    onClose: onClose,
    trigger: trigger
  }, React.createElement(Slideshow, {
    hasShadow: false,
    images: images,
    isRounded: false,
    isShowingBulletNavigation: false,
    isShowingIndex: areThumbnailsActive,
    isShowingThumbnails: areThumbnailsActive,
    startIndex: startIndex,
    thumbnails: images
  }));
};
Component.displayName = 'Gallery';
Component.defaultProps = {
  trigger: null,
  isOpen: undefined,
  onClose: undefined,
  startIndex: 0
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  images: PropTypes.arrayOf(PropTypes.shape({
    descriptionText: PropTypes.string,
    sizes: PropTypes.string,
    srcSet: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string.isRequired
  })).isRequired,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  startIndex: PropTypes.number,
  trigger: PropTypes.node
} : {};